module.exports = __webpack_public_path__ + "static/img/4_Lisa.e7bda415.jpg";